import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import queryString from "app/services/queryStringService";
import _ from "lodash";

import Tooltip from "rc-tooltip";
import paginationFactory from "react-bootstrap-table2-paginator";
import { getLimitBalance } from "app/services/creditService";
import config from "config.json";
import moment from "moment";

import { MdRefresh, MdSearch } from "react-icons/md";
import { Button } from "react-bootstrap";
import { AiFillFileExcel } from "react-icons/ai";
import HandyScroll from "app/common/Scroll";

const DebitLimitBalanceSheet = (props) => {
  const { dateTimeFormat } = config;

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [memId, setMemId] = useState(0);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [SearchUserName, setSearchUserName] = useState("");
  const [TransactionMode, setTransactionMode] = useState("Debit");

  const dateFormater = (cell, row) => {
    return moment(cell).format(dateTimeFormat);
  };

  const remarksFormatter = (cell, row) => {
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{row.narration}</div>}
      >
        <p>{row.narration.substring(0, 10)}...</p>
      </Tooltip>
    );
  };

  const columns = [
    {
      dataField: "sln",
      text: "Transaction Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "member.uniqueIdentity",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "member.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionDate",
      text: "Transaction Date",
      formatter: dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionType",
      text: "Transaction Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "narration",
      text: "Remarks",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: remarksFormatter,
    },
    {
      dataField: "transactionMode",
      text: "Transaction Mode",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionAmount",
      text: "Transaction Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px" };
      },
    },
    {
      dataField: "leadgerBalance",
      text: "Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const refreshFilter = async (e) => {
    setFromDate("");
    setToDate("");
    setTransactionMode("");
    setSearchUserName("");
    setTimeout(async () => {
      await resetTableHandler();
    }, 10);
  };

  const loadTransaction = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      SearchUserName,
      TransactionMode: "Debit",
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getLimitBalance(query);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(responseData);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  const resetTableHandler = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      SearchUserName,
      TransactionMode: "Debit",
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getLimitBalance(query);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(responseData);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  useEffect(() => {
    loadTransaction();
  }, [page, sizePerPage]);

  useEffect(() => {
    if (props.memberId !== memId) {
      window.setTimeout(async () => {
        await loadTransaction();
      }, 100);
    }
  }, [props.memberId, memId]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    if (name === "FromDate") setFromDate(value);
    else if (name === "ToDate") setToDate(value);
    else if (name === "SearchUserName") setSearchUserName(value);
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const handleExport = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      // await exportMember();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size </label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 10,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <div className="card card-body mb-3">
        <div className="row mb-2">
          <div className="col-md-3">
            <div className="form-group">
              <label> Date From</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="FromDate"
              value={FromDate}
              onChange={handleSearchChanges}
            />
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label> Date To</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="ToDate"
              value={ToDate}
              onChange={handleSearchChanges}
            />
          </div>
          <div className="col-md-2 ">
            <div className="form-group">
              <label> Username</label>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Username"
              value={SearchUserName}
              name="SearchUserName"
              onChange={handleSearchChanges}
            />
          </div>
          <div
            className="col-md-4 d-flex justify-content-end"
            style={{ marginTop: "37px" }}
          >
            <button
              className="btn btn-outline-primary d-flex align-items-center"
              onClick={handleSearch}
            >
              <MdSearch className="mx-2" />
            </button>

            <button
              className="btn btn-outline-primary d-flex align-items-center mx-2"
              onClick={refreshFilter}
            >
              <MdRefresh className="mx-2" />
            </button>
          </div>
        </div>
        <HandyScroll>
          <div
            class="spacious-container"
            data-handy-scroll
            style={{ overflow: "auto" }}
          >
            <BootstrapTable
              hover
              remote
              keyField="uniqueIdentity"
              data={data}
              columns={columns}
              pagination={dataCount > 0 && paginationFactory(paginationOptions)}
              onTableChange={handleTableChange}
              noDataIndication={NoDataIndication}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </HandyScroll>
      </div>
    </>
  );
};

export default DebitLimitBalanceSheet;
